module.exports = __webpack_public_path__ + "static/media/Promo_Card_ID.40d74af6.jpg";